
import { Button } from '@/components/ui/button';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { useLanguage } from '@/context/LanguageContext';

const CtaSection = () => {
  const { t } = useLanguage();
  
  return (
    <section className="py-16 md:py-24">
      <div className="container mx-auto px-4">
        <div className="max-w-5xl mx-auto bg-gradient-to-r from-blue-600 to-blue-700 rounded-2xl overflow-hidden shadow-xl">
          <div className="flex flex-col md:flex-row">
            <div className="md:w-7/12 p-8 md:p-12 lg:p-16">
              <h2 className="text-3xl md:text-4xl font-bold text-white mb-6 animate-fade-in-up leading-tight">
                {t('startYourJourneyToday')}
              </h2>
              <p className="text-lg text-blue-100 mb-8 md:mb-10 max-w-xl animate-fade-in-up [animation-delay:100ms] leading-relaxed">
                {t('ctaDescription')}
              </p>
              
              <div className="flex flex-col sm:flex-row gap-4 animate-fade-in-up [animation-delay:200ms]">
                <Button 
                  size="lg"
                  className="bg-white text-blue-700 hover:bg-blue-50 hover:text-blue-800 font-semibold px-6 py-3 shadow-lg transition-all duration-200 hover:shadow-xl"
                  asChild
                >
                  <Link to="/find" className="flex items-center justify-center text-blue-700 hover:text-blue-800">
                    {t('findATherapist')}
                    <ArrowRight className="ml-2 h-5 w-5" />
                  </Link>
                </Button>
                
                <Button 
                  variant="outline" 
                  size="lg"
                  className="border-2 border-white text-white bg-transparent hover:bg-white hover:text-blue-700 font-semibold px-6 py-3 shadow-lg transition-all duration-200 hover:shadow-xl"
                  asChild
                >
                  <Link to="/how-it-works" className="flex items-center justify-center text-white hover:text-blue-700">
                    {t('learnHowItWorks')}
                  </Link>
                </Button>
              </div>
            </div>
            
            <div className="hidden md:block md:w-5/12 bg-blue-800 relative overflow-hidden">
              <div className="absolute inset-0 bg-pattern opacity-10"></div>
              
              {/* Abstract shapes */}
              <div className="absolute top-1/4 left-1/4 w-32 h-32 bg-blue-400/30 rounded-full blur-xl"></div>
              <div className="absolute bottom-1/3 right-1/3 w-40 h-40 bg-blue-300/20 rounded-full blur-xl"></div>
              
              {/* Stats */}
              <div className="absolute inset-0 flex flex-col justify-center items-center p-8 space-y-8 text-center">
                <div className="animate-fade-in-up">
                  <p className="text-3xl md:text-4xl font-bold text-white mb-2">2,500+</p>
                  <p className="text-blue-200 font-medium">{t('verifiedProfessionals')}</p>
                </div>
                
                <div className="animate-fade-in-up [animation-delay:100ms]">
                  <p className="text-3xl md:text-4xl font-bold text-white mb-2">50+</p>
                  <p className="text-blue-200 font-medium">{t('countries')}</p>
                </div>
                
                <div className="animate-fade-in-up [animation-delay:200ms]">
                  <p className="text-3xl md:text-4xl font-bold text-white mb-2">100,000+</p>
                  <p className="text-blue-200 font-medium">Successful Sessions</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CtaSection;
